import React from 'react'
import { cn } from '../../../utils/classnames'

const CustomRoundedButton = ({
  disabled = false,
  children,
  icon: Icon,
  loading = false,
  loadingText = null,
  className = '',
  ...props
}) => {
  const isDisabled = loading || disabled

  return (
    <button
      disabled={isDisabled}
      {...props}
      className={cn(
        'px-6 py-2 rounded-custom100 text-sm font-semibold transition duration-200 items-center flex gap-2 justify-center',
        isDisabled
          ? 'bg-tealMedium text-white opacity-50 border-r-2 border-b-2 cursor-not-allowed border-tealBase'
          : 'bg-tealMedium text-white hover:opacity-90 border-r-2 border-b-2 border-tealBase',
        className
      )}
    >
      {loading && (
        <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
      )}
      {Icon && <Icon size={16} strokeWidth={2} />}
      {loading ? (loadingText || children) : children}
    </button>
  )
}

export default CustomRoundedButton
